import Button from "@mui/material/Button";
import { SaveAlt } from "@material-ui/icons";

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import styles from "./PartnerConfiguration.module.scss";
import apis from "../../api/apis";
import { IBaseModel } from "../../interfaces/base";
import { API_INTEGRATION_ID } from "../../config";
import {
  IPartnerStorePartnerRequestModel,
  IStorePartner,
} from "../../interfaces/configuration";
import LoadingComponent from "../loadingComponent/LoadingComponent";
import axios from "axios";
import { APIResponseType } from "../../config/enumApiResponseTypes";
import { Alert } from "@mui/material";

interface DeliveryPartner {
  id: number;
  partner: String;
  isEnabled: boolean;
}

const sampleData: DeliveryPartner[] = [
  {
    id: 1,
    partner: "Pick Me",
    isEnabled: false,
  },
  {
    id: 2,
    partner: "Uber",
    isEnabled: true,
  },
  {
    id: 3,
    partner: "Deliveroo",
    isEnabled: true,
  },
  {
    id: 4,
    partner: "Just eat",
    isEnabled: false,
  },
  {
    id: 5,
    partner: "Ecommerce",
    isEnabled: false,
  },
];

const PartnerConfiguration = () => {
  const [partners, setpartners] = useState<IStorePartner[]>([]);
  const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
  const [loading, setloading] = useState<boolean>(false);
  const [error, seterror] = useState<boolean>();
  const [isUpdateSuccess, setisUpdateSuccess] = useState<boolean>(false);
  //console.table(partners);

  const { user } = useSelector((state: any) => state.authentication);

  const history = useHistory();

  useEffect(() => {
    getPartners();
  }, []);

  useEffect(() => {
    if (isUpdateSuccess) {
      setTimeout(() => {
        setisUpdateSuccess(false);
        // history.push()
        history.push("/configuration");
      }, 5000);
    }

    if (error) {
      setTimeout(() => {
        //setisUpdateSuccess(false);
        seterror(false);
        // history.push()
        history.push("/configuration");
      }, 5000);
    }
  }, [isUpdateSuccess, error]);

  const hadnlePartner = (e: any, id: number) => {
    const { checked } = e.target;

    //console.log(id);
    setIsAllSelected(false);

    setpartners((prevState: IStorePartner[]) =>
      prevState.map((partner: IStorePartner) =>
        partner.StorePartnerId === id
          ? {
              ...partner,
              IsOrderEnabled: checked,
            }
          : partner
      )
    );
  };

  const handleIsAllSeleted = (e: any) => {
    const { checked } = e.target;
    setIsAllSelected(checked);

    setpartners((prevState: IStorePartner[]) =>
      prevState.map((partner: IStorePartner) => ({
        ...partner,
        IsOrderEnabled: checked,
      }))
    );
  };

  const getPartners = async () => {
    setloading(true);
    const requestModel: IBaseModel = {
      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
        IsUrbanPiper: user?.IsUrbanPiper ?? false,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    };
    const response = await apis.configuration.getStorePartners(requestModel);

    //console.log(response.ResponseData.Storepartners);
    setpartners(response.ResponseData.Storepartners);
    setloading(false);
  };

  const saveSettings = async () => {
    // console.log("clicked");

    try {
      // const requestModel: IBaseModel = {
      //   RequestId: API_INTEGRATION_ID,
      //   IntegrationId: API_INTEGRATION_ID,
      //   ApiKey: "",
      //   UID: {
      //     CompanyKey: user?.CompanyKey ?? 0,
      //     LocationKey: user?.LocationKey ?? 0,
      //     UserKey: user?.UserKey ?? 0,
      //     EnvironmentName: user?.EnvironmentName ?? 0,
      //     IsUrbanPiper: user?.IsUrbanPiper ?? false,
      //   },
      //   RequestingUser: 0,
      //   RequestingId: "",
      //   Schema: "",
      //   ValidationMessages: [],
      //   IsApprovedStatus: 0,
      //   IsActive: 0,
      // };

      setloading(true);
      const updateRequestModel: IPartnerStorePartnerRequestModel = {
        storePartners: partners,
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user?.CompanyKey ?? 0,
          LocationKey: user?.LocationKey ?? 0,
          UserKey: user?.UserKey ?? 0,
          EnvironmentName: user?.EnvironmentName ?? 0,
          IsUrbanPiper: user?.IsUrbanPiper ?? false,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
      };

      const response = await apis.configuration.updateStorePartners(
        updateRequestModel
      );
      setloading(false);

      if (response.ResponseType === APIResponseType.Success) {
        seterror(false);
        setisUpdateSuccess(true);
        // history.push("/configuration");
      }
      if (response.ResponseType === APIResponseType.Error) {
        seterror(true);
        setisUpdateSuccess(false);
      }
      // const response = await axios.post(
      //   "PartnerStore/UpdateStorePartnersStatus",
      //   updateRequestModel
      // );

      // console.log(response);
      // history.push("/configuration");
    } catch (error) {
      seterror(true);
      // console.log(error);
    }
  };

  if (loading) {
    return <LoadingComponent />;
  }
  return (
    <div className={styles.wrapper}>
      {isUpdateSuccess && <Alert severity="success">Update successfull</Alert>}
      {error && <Alert severity="error">Update failed</Alert>}
      <div className={styles.partners}>
        <table>
          <thead>
            <tr>
              <th>Partner</th>
              <th>
                <div className={styles.table_header}>
                  <span>Enable for ordering</span>

                  <label
                    className={isAllSelected ? styles.switch_on : styles.switch}
                  >
                    <input
                      type="checkbox"
                      onChange={(e: any) => handleIsAllSeleted(e)}
                      className={
                        isAllSelected ? styles.switch_on : styles.switch
                      }
                      checked={isAllSelected === true ? true : false}
                    />
                    <div></div>
                  </label>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {partners.length > 0 &&
              partners.map((partner: IStorePartner) => (
                <tr>
                  <td>{partner.OrderTypeName}</td>
                  <td>
                    <label
                      className={
                        partner.IsOrderEnabled
                          ? styles.switch_on
                          : styles.switch
                      }
                    >
                      <input
                        type="checkbox"
                        checked={partner.IsOrderEnabled === true ? true : false}
                        onChange={(e) =>
                          hadnlePartner(e, partner.StorePartnerId)
                        }
                      />
                      <div></div>
                    </label>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        <div className={styles.button_wrapper}>
          <Button
            variant="outlined"
            startIcon={<SaveAlt />}
            onClick={saveSettings}
          >
            Update
          </Button>

          <Link to="/configuration/details">
            <Button
              variant="outlined"
              startIcon={<SaveAlt />}
              onClick={() => {}}
            >
              Store details
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PartnerConfiguration;
